export default __webpack_public_path__ + "static/media/chat_button_150x150.68f958bb.png";